import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type UploadVideo = {
  formData: FormData;
};

export type UploadVideoParams = RequestConfig<UploadVideo>;

export const uploadVideo = async ({ params, config }: UploadVideoParams) =>
  api.post(`/api/videos/upload`, params.formData, config);
